<template>
    <div class="centerPage" v-if="invite">
        <div class="centerPage_bigTitle">
            <img src="~images/logo.svg" alt="" />
            Join {{invite.workspaceName}} on EZ Retro
        </div>
        <div class="centerPage_whiteBox whiteBox">
            <form>
                <label>Name</label>
                <input class="input" v-model.trim="signupForm.name" type="text" autocomplete="name" />

                <label>Email</label>
                <input class="input" disabled v-model.trim="signupForm.email" type="email" autocomplete="username email" />

                <label>Password</label>
                <input class="input" v-model.trim="signupForm.password" type="password" autocomplete="new-password" />

                <div v-if="errorMsg !== ''" class="error-msg">
                    {{ errorMsg }}
                </div>
                <button type="button" :disabled="loading" @click="signup" v-bind:class="[loading ? 'loading' : '', 'button']">
                    Sign Up
                </button>
            </form>
        </div>

        <div class="centerPage_whiteBox centerPage_whiteBox_additional">
            Already have an account?
            <router-link class="centerPage_forgotPass_link" to="login">
                Sign in
            </router-link>
        </div>
    </div>
    <div v-else>
        {{test}}
    </div>
</template>

<script>
  import firebaseFirestore ,{ AUTH, ANALYTICS } from 'src/firebase-config';
  import firebase from 'firebase';
  export default {
    data() {
      return {
        inviteID: this.$router.currentRoute.path.substr(1).split('/')[1],
        invite:null,
        test:'Loding',
        signupForm: {
          name: '',
          email: '',
          password: ''
        },
        errorMsg: '',
        loading: false
      };
    },
    methods: {
      signup() {
        this.loading = true;
        AUTH.createUserWithEmailAndPassword(this.signupForm.email, this.signupForm.password)
          .then(async user => {
            this.$store.commit('setCurrentUser', user);
            ANALYTICS.logEvent('user_created',{
              fromInvite:true,
              email:this.signupForm.email,
            });
            await firebaseFirestore.collection('usersInfo').doc(user.user.uid)
              .set({
                email:this.signupForm.email,
                name: this.signupForm.name,
                userWorkspaces: firebase.firestore.FieldValue.arrayUnion(this.invite.workspaceId),
                allWorkspaces: firebase.firestore.FieldValue.arrayUnion(this.invite.workspaceId),
                notifications:true
              })
              .then(() => {
                this.loading = false;
                firebaseFirestore.collection('workspaces').doc(this.invite.workspaceId).update({
                  invites:firebase.firestore.FieldValue.arrayRemove(this.inviteID),
                  users: firebase.firestore.FieldValue.arrayUnion(user.user.uid)
                }).then((resp)=>{
                  AUTH.currentUser.sendEmailVerification().then(()=>{
                    this.$router.push('/');
                    firebaseFirestore.collection('invites').doc(this.inviteID).delete();
                  })
                })
              })
              .catch(err => {
                console.log(err);
                this.loading = false;
                this.errorMsg = err.message;
              });
          })
          .catch(err => {
            console.log(err);
            this.loading = false;
            this.errorMsg = err.message;
          });
      }
    },
    beforeMount() {
      if (AUTH.currentUser) {
        this.$router.push('/dashboard');
      }
    },
    mounted() {
      firebaseFirestore.collection('invites').doc(this.inviteID).get()
        .then((resp)=>{
          this.invite = resp.data();
          if(this.invite){
            this.signupForm.email = this.invite.inviteEmail
          }else{
            this.test = "Invite doesn't exist"
          }
        })

      ANALYTICS.logEvent('page_view');
    }
  };
</script>

<style></style>
